module.exports = __webpack_public_path__ + "img/pro4.e5dcc67f.png";